// @flow
import React from 'react';
import gql from 'graphql-tag';
import buildAnalyticsDataLayer from './buildAnalyticsDataLayer';
import {trigger as edapTrigger} from '../../utils/edapWrapper';

import type {SearchQueryResults} from '../../queries/searchQuery';

export const fragments = {
    searchResult: gql`
        fragment ADLSearchResult on SearchResult {
            parsedParams {
                q
                coreFilters {
                    adults
                    children
                    pets
                    minBedrooms
                    maxBedrooms
                    minBathrooms
                    maxBathrooms
                    minPrice
                    maxPrice
                    minSleeps
                }
                dates {
                    arrivalDate
                    departureDate
                }
                sort
            }
            page
            pageSize
            pageCount
            resultCount
            fromRecord
            toRecord
            pinnedListing {
                listing {
                    listingId
                }
            }
            listings {
                listingId
            }
            filterGroups {
                filters {
                    checked
                    filter {
                        groupId
                        id
                    }
                }
            }
            geography {
                lbsId
                name
                description
                location {
                    latitude
                    longitude
                }
                primaryGeoType
                breadcrumbs {
                    name
                    countryCode
                    location {
                        latitude
                        longitude
                    }
                    primaryGeoType
                }
            }
        }
    `,
    query: gql`
        fragment RequestMarkerFragment on Query {
            requestmarker
        }
    `
};

export type Props = {
    results: ?SearchQueryResults,
    requestmarker: string
};

export default class AnalyticsDataLayer extends React.Component<Props> {
    componentDidMount() {
        this.updateADL({skipPageView: true});
    }

    componentDidUpdate({results: prevResults}: Props) {
        // deep comparison with JSON.stringify shows better results especially for deep nested objects
        // https://www.measurethat.net/Benchmarks/Show/1854/0/lodash-isequal-test
        const prevResultsStr = JSON.stringify(prevResults);
        const resultsStr = JSON.stringify(this.props.results);

        if (!!this.props.results && prevResultsStr !== resultsStr) {
            this.updateADL({skipPageView: false});
        }
    }

    updateADL(options: {skipPageView: boolean}) {
        const {skipPageView} = options;

        if (this.props.results) {
            window.analyticsdatalayer = buildAnalyticsDataLayer(
                this.props.results,
                {
                    ...window.analyticsdatalayer,
                    requestmarker: this.props.requestmarker
                }
            );

            if (!skipPageView) {
                edapTrigger('edap.flush');
                edapTrigger('pageview');
            }
        }
    }

    render() {
        return null;
    }
}
